import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import ContactUsInfo from './ContactUsInfo';
class ContactUs extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/contact');
}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Contact Us"/>
          <ContactUsInfo/>
          <Footer />
        </div>
    );
  }
}

export default ContactUs;
